import React from "react";
import { Link } from "gatsby";
import logo from "../img/CypressDataDefenseLogo.svg";

const Navbar = class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      navBarActiveClass: "",
      scroll: "",
      top: "",
    };
    this.handleScroll = this.handleScroll.bind(this);
  }

  handleScroll() {
    this.setState({ scroll: window.scrollY });
  }

  componentDidMount() {
    const el = document.getElementById("navbar");
    this.setState({ top: el.offsetTop, height: el.offsetHeight });
    window.addEventListener("scroll", this.handleScroll);
  }

  toggleHamburger = () => {
    // toggle the active boolean in the state
    this.setState(
      {
        active: !this.state.active,
      },
      // after state has been updated,
      () => {
        // set the class in state for the navbar accordingly
        this.state.active
          ? this.setState({
            navBarActiveClass: "is-active",
          })
          : this.setState({
            navBarActiveClass: "",
          });
      }
    );
  };

  render() {
    return (
      <div>
        <nav
          className="navbar is-transparent is-fixed-top"
          role="navigation"
          id="navbar"
          aria-label="main-navigation"
          style={
            this.state.scroll > this.state.top
              ? {
                background: "rgba(3, 4, 25, 0.90)",
                boxShadow: "0 0 5px rgba(0, 0, 0, 0.19)",
              }
              : {
                background: "rgba(3, 4, 25, 0.55)",
                padding: "8px 0"
              }
          }
        >
          <div className="container">
            <div
              className="navbar-brand"
            >
              <Link to="/" title="Logo">
                <img
                  src={logo}
                  alt="Kaldi"
                  style={{ padding: 10, width: 200 }}
                />
              </Link>
              {/* Hamburger menu */}
              <div
                className={`navbar-burger burger ${this.state.navBarActiveClass}`}
                data-target="navMenu"
                role="button"
                tabIndex="0"
                onClick={() => this.toggleHamburger()}
                onKeyDown={() => this.toggleHamburger()}
              >
                <span />
                <span />
                <span />
              </div>
            </div>
            <div
              id="navMenu"
              className={`navbar-menu ${this.state.navBarActiveClass}`}>
                          {this.state.active ? (
              <div className="mobile-menu-wrapper">
                <div className="navbar-link" id="mobile-wwd">Solutions<div className="chevron"></div></div>
                <div className="navbar-dropdown has-text-centered mobile" id="mobile-wwd-dropdown">
                  <a
                    className="navbar-item"
                    href="/application-security-services/easy-ssdlc"
                  >
                    EASy
                  </a>
                  <a
                    className="navbar-item"
                    href="/security-assessments/network-application-security"
                  >
                    Security Testing
                  </a>
                  <a
                    className="navbar-item"
                    href="/security-assessments/mobile-web-application"
                  >
                    Mobile & Web Application
                  </a>
                  <a
                    className="navbar-item"
                    href="/security-assessments/sdlc-consulting"
                  >
                    Secure SDLC Consulting Services
                  </a>
                </div>
                <Link className="navbar-item" to="/about-us">
                  About Us
                </Link>
                <div className="navbar-link" id="mobile-resources">Resources<div className="chevron"></div></div>
                <div className="navbar-dropdown mobile has-text-centered" id="mobile-resources-dropdown">
                  <a
                    className="navbar-item"
                    href="/blog"
                  >
                    Blog Posts
                  </a>
                  <a
                    className="navbar-item"
                    href="/resources"
                  >
                    Resource Center
                  </a>
                  <a
                    className="navbar-item"
                    href="/secure-software-development-life-cycle"
                  >
                    What Is SSDLC
                  </a>
                </div>
                <Link className="navbar-item" to="/contact">
                    Contact Us
                </Link>
              </div>
              ) : (
              <div
                style={{
                  display: 'flex',
                  width: '100%'
                 }}>
                <div className="navbar-start has-text-centered">
                  <div className="navbar-item has-dropdown is-hoverable">
                    <div className="navbar-link">Solutions<div className="chevron"></div></div>
                      <div className="navbar-dropdown is-hidden-mobile is-boxed">
                        <a
                        className="navbar-item"
                        href="/application-security-services/easy-ssdlc"
                      >
                        EASy
                      </a>
                      <a
                        className="navbar-item"
                        href="/security-assessments/network-application-security"
                      >
                        Security Testing
                      </a>
                      <a
                        className="navbar-item"
                        href="/security-assessments/mobile-web-application"
                      >
                        Mobile & Web Application
                      </a>
                      <a
                        className="navbar-item"
                        href="/security-assessments/sdlc-consulting"
                      >
                        Secure SDLC Consulting Services
                      </a>
                    </div>
                  </div>

                  <Link className="navbar-item" to="/about-us">
                    About Us
                  </Link>
                  <div className="navbar-item has-dropdown is-hoverable">
                    <div className="navbar-link">Resources<div className="chevron"></div></div>
                    <div className="navbar-dropdown is-hidden-mobile is-boxed">
                      <a
                        className="navbar-item"
                        href="/blog"
                      >
                        Blog Posts
                      </a>
                      <a
                        className="navbar-item"
                        href="/resources"
                      >
                        Resource Center
                      </a>
                      <a
                        className="navbar-item"
                        href="/secure-software-development-life-cycle"
                      >
                        What Is SSDLC
                      </a>
                    </div>
                  </div>
                </div>
                <div className="navbar-end has-text-centered">
                  <Link to="/contact">
                    <button className="btn-golden">Contact Us</button>
                  </Link>
                </div>
              </div>
              )}
            </div>
          </div>
        </nav>
      </div>
    );
  }
};

export default Navbar;
